import { render } from "./ApplicantListView.vue?vue&type=template&id=128f8715&scoped=true"
import script from "./ApplicantListView.vue?vue&type=script&lang=js"
export * from "./ApplicantListView.vue?vue&type=script&lang=js"

import "@/assets/css/applicantList.css?vue&type=style&index=0&id=128f8715&lang=css&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128f8715"]])

export default __exports__